import React from "react";
import CableClearance from "./cable-clearance";
import SurfaceVoltage from "./surface-voltage";
import Error from "../../../assets/icons/Error";

const Cable: React.FC = () => {
    
    const [showAlert, setShowAlert] = React.useState({
        voltageLossWarning: false,
        exceed15Warning: false,
    });

    return (
        <div className="flex flex-col w-full h-full gap-[16px]">
            {showAlert?.voltageLossWarning && (
                <div className="flex p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-error-500 border-darkcolor-400">
                    <Error className="mr-2" />
                    <p className="text-[14px] font-bold leading-[20px] text-neutral-25">
                        Voltage drop is high. Please choose a different cable.
                    </p>
                </div>
            )}
            {showAlert?.exceed15Warning && (
                <div className="flex p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-error-500 border-darkcolor-400 mt-1">
                    <Error className="mr-2" />
                    <p className="text-[14px] font-bold leading-[20px] text-neutral-25">
                        % V.Drop / Nm Plate motor volt exceeds recommended limit of 15%, motor
                        might not start, change Cable/Motor selection.
                    </p>
                </div>
            )}
            <CableClearance />
            <SurfaceVoltage setShowError={setShowAlert} />
        </div>
    );
};

export default Cable;
